export const normalizeTaxNumberInput = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, "");

export const getTaxNumberError = (value) => {
  const raw = normalizeTaxNumberInput(value);
  if (!raw) return "";

  if (/[^0-9/-]/.test(raw)) {
    return "Ungültige Steuernummer (nur Ziffern sowie / oder -)";
  }
  if (/^[/-]|[/-]$|[/-]{2,}/.test(raw)) {
    return "Ungültige Steuernummer (Trennzeichen prüfen)";
  }

  const digitsOnly = raw.replace(/[/-]/g, "");
  if (!/^\d+$/.test(digitsOnly)) {
    return "Ungültige Steuernummer";
  }

  if (![10, 11, 12, 13].includes(digitsOnly.length)) {
    return "Ungültige Steuernummer (10, 11, 12 oder 13 Ziffern)";
  }

  if (raw.includes("/") && raw.includes("-")) {
    return "Ungültige Steuernummer (einheitliches Trennzeichen verwenden)";
  }

  if (raw.includes("/") || raw.includes("-")) {
    const sep = raw.includes("/") ? "/" : "-";
    const parts = raw.split(sep);
    if (parts.length !== 3 || parts.some((p) => !/^\d+$/.test(p))) {
      return "Ungültige Steuernummer (z. B. 12/345/67890)";
    }
  }

  return "";
};
